module.exports = __webpack_public_path__ + "static/api_key_create-56f0df755cb777dc7f062ddc12eee127.png";